<div *ngIf="layerSymbol" class="draw-options">
    <div class="clearfix legendWideControlGroup font-family">
        <label class="pull-left">Font Family: </label>
        <select class="pull-right" [(ngModel)]="fontFamily">
            <option [value]="font" *ngFor="let font of fontFamilyList">{{ font }}</option>
        </select>

    </div>
    <div class="clearfix legendWideControlGroup horizontal-alignment">
        <label class="pull-left">Horizontal Alignment:</label>
        <select class="pull-right" [(ngModel)]="horizontalAlignment">
            <option [value]="align" *ngFor="let align of horizontalAlignments">{{ align }}</option>
        </select>

    </div>
    <div class="clearfix legendWideControlGroup vertical-alignment">
        <label class="pull-left">Vertical Alignment:</label>
        <select class="pull-right" [(ngModel)]="verticalAlignment">
            <option [value]="align" *ngFor="let align of verticalAlignments">{{ align }}</option>
        </select>
    </div>

    <div class="clearfix legendWideControlGroup">
        <label class="pull-left" (click)="colorPicker.showColorPicker = !colorPicker.showColorPicker">Font Color:</label>
        <mc-color-picker-ng #colorPicker 
            class="color-swatch right"
            [color]="symbolColor" 
            (colorChange)="updateColorFromPicker($event)">
        </mc-color-picker-ng>
        <a class="right cancel-button" *ngIf="symbolColor !== originalColor" (click)="cancelColorChange()">Cancel</a>
    </div>
    
    <div class="clearfix legendWideControlGroup font-size">
        <label class="pull-left">Font Size: </label>
        <select class="pull-right" [(ngModel)]="fontSize">
            <option [value]="size" *ngFor="let size of textSizes">{{ size }}</option>
        </select>
    </div>

    <div class="clearfix legendWideControlGroup font-style">
        <label class="pull-left">Font Style: </label>
        <nav class="pull-right">
            <label class="btn-small btn btn-grouped">
                <input type="checkbox" [(ngModel)]="fontWeight">
                <span class="label-small">Weight</span>
            </label>
            <label class="btn-small btn btn-grouped">
                <input type="checkbox" [(ngModel)]="fontStyle">
                <span class="label-small">Italic</span>
            </label>
            <label class="btn-small btn btn-grouped">
                <input type="checkbox" [(ngModel)]="fontDecoration">
                <span class="label-small">Underline</span>
            </label>
        </nav>
    </div>

    <div [hidden]="!showTextInput" class="clearfix legendWideControlGroup text-input">
        <label class="pull-left">Text Input: </label>
        <br />
        <input type="text" [(ngModel)]="symbolText" placeholder="Enter Text..." />
    </div>
</div>
